module.exports = require('./helpers/bundle-url').getBundleURL('9p9yL') + "OpenSans-Regular.edf9e01b.ttf";